import http from "../http-common";

class CasefileDataService {
  getAll() {
    return http.get("/casefiles");
  }

  getAllRefType(id) {
    return http.get(`/byref/${id}`);
  }

  // Paginated fetch for refType listing (department) with optional search and count
  getPaginatedByRefType(refType, params) {
    return http.get(`/byref/${refType}`, { params });
  }

  getAllBranch(branch) {
    return http.get(`/bybranch/${branch}`);
  }
  
  // Paginated fetch for branch listing
  getPaginatedByBranch(branch, params) {
    return http.get(`/bybranch/${branch}`, { params });
  }
  // Paginated fetch for branch + status listing
  getPaginatedByStatusBranch(fileStatus, branch, params) {
    return http.get(`/detailByBranch/${fileStatus}/${branch}`, { params });
  }
  getAllStatusRefType(fileStatus, refType) {
    return http.get(`/detailByRef/${fileStatus}/${refType}`);
  }

  getAllStatusBranch(fileStatus, branch) {
    return http.get(`/detailByBranch/${fileStatus}/${branch}`);
  }

  get(id) {
    return http.get(`/casefiles/${id}`);
  }

  create(data) {
    return http.post("/casefiles", data);
  }

  update(id, data) {
    return http.put(`/casefiles/${id}`, data);
  }

  delete(id) {
    return http.delete(`/casefiles/${id}`);
  }

  deleteAll() {
    return http.delete(`/casefiles`);
  }

  getPaginated(params) {
    return http.get("/casefiles/paginated", { params });
  }

  getPaginatedActive(params) {
    return http.get("/casefiles/paginated-active", { params });
  }

  getPaginatedClosed(params) {
    return http.get("/casefiles/paginated-closed", { params });
  }

  // Generic counts grouped endpoint
  getCountsBy(groupBy, params = {}) {
    // Ensure array params are stringified as JSON for backend buildUserWhere
    const serializedParams = { groupBy };
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        serializedParams[key] = JSON.stringify(value);
      } else {
        serializedParams[key] = value;
      }
    }
    return http.get(`/casefiles/counts`, { params: serializedParams });
  }

  // Counts grouped by field AND by status category (Active vs Archived)
  getCountsByStatus(groupBy, params = {}) {
    const serializedParams = { groupBy };
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        serializedParams[key] = JSON.stringify(value);
      } else {
        serializedParams[key] = value;
      }
    }
    return http.get(`/casefiles/counts/by-status`, { params: serializedParams });
  }
}

export default new CasefileDataService();
